import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { getQueryParam, path } from '../../../Utils';
import { connect } from 'react-redux';
import { MetaActionCreators } from '../../../Store/ActionCreators/MetaActionCreators';

class HandleCallbackResetPassword extends PureComponent {
    state = {
        token: '',
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (path(nextProps, 'location', 'search') && prevState.token.length === 0) {
            const parsedHash = getQueryParam(nextProps.location.search, 'hash');

            return {
                token: parsedHash,
            };
        } else {
            return null;
        }
    }

    componentDidMount() {
        const { token } = this.state;
        const { setToken } = this.props;

        token && setToken(token);
    }

    render() {
        const { token } = this.state;
        const isTokenExist = typeof token === 'string' && token.length > 0;

        return isTokenExist ? <Redirect to={'/update-password'} /> : <Redirect to={'/reset-password'} />;
    }
}

const mapDispatchToProps = dispatch => ({
    setToken(token) {
        dispatch(MetaActionCreators.setToken(token));
    },
});

export default connect(
    null,
    mapDispatchToProps,
)(HandleCallbackResetPassword);



// WEBPACK FOOTER //
// ./src/UI/Containers/HandleCallbackForResetPassword/HandleCallbackForResetPassword.js